import { OtaPlan } from '@/api/ota/types';

const ACTIVE_OTA_PLAN_STATUSES = ['pending', 'in_progress', 'cancelling'] as const;

export type ActiveOtaPlanStatus = (typeof ACTIVE_OTA_PLAN_STATUSES)[number];

export const isOtaPlanActive = <TPlan extends Pick<OtaPlan, 'status'>>(
    plan: TPlan | null | undefined
): plan is TPlan & { status: ActiveOtaPlanStatus } =>
    !!plan && ACTIVE_OTA_PLAN_STATUSES.includes(plan.status as ActiveOtaPlanStatus);
